import mutations from './mutations';
import getters from './getters';
import actions from './actions';

export const STORE_NAME = '$_user';

export function getStore() {
  const state = {
    profile: {},
  };

  return {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
  };
}

export default {
  register: (rootStore) => {
    if (rootStore.state[STORE_NAME]) {
      rootStore.unregisterModule(STORE_NAME);
    }
    rootStore.registerModule(STORE_NAME, getStore());
  },
};



// WEBPACK FOOTER //
// ./src/views/Profile/store/index.js